import { CancelOutlined as CancelOutlinedIcon } from '@mui/icons-material';

import { InteractiveChip } from './InteractiveChip';

import type { InteractiveChipProps } from './InteractiveChip';
import type { FunctionComponent } from 'react';

export const RemovableChip: FunctionComponent<Omit<InteractiveChipProps, 'icon'>> = ({
    isActive = false,
    label,
    onDelete,
}) => (
    <InteractiveChip
        icon={<CancelOutlinedIcon fontSize="small" />}
        isActive={isActive}
        label={label}
        onDelete={onDelete}
    />
);
